/**
 * @fileoverview AR-805 — ports whose backend does not exist yet.
 *
 * Phase 4 (grade push) has no backend at all and is out of this delivery by
 * product decision (2026-07-29). The surface that depends on it is hidden by
 * the provider's capabilities — this implementation exists so the port stays
 * total, and it fails loudly if something slips through.
 */

import { ClassroomPortError } from '../types'
import { GradePort } from '../ports'

const PHASE4_NOT_AVAILABLE = 'AR-805 phase 4 (grade push) has no backend yet'

export const unavailableGrade: GradePort = {
  async pushGrade(): Promise<never> {
    throw new ClassroomPortError('classroom_api_error', PHASE4_NOT_AVAILABLE)
  },
}
